import type { i18n as I18nInstance } from "i18next";

export enum BlogCategory {
  CompanyNews = "company-news",
  Product = "product",
  IndustryInsights = "industry-insights",
  Engineering = "engineering",
  CustomerStories = "customer-stories",
}

const allIds = Object.values(BlogCategory) as string[];

export function getAllCategoryIds(): string[] {
  return allIds;
}

export function isValidCategory(value: string): value is BlogCategory {
  return allIds.includes(value);
}

export function getCategorySlug(
  categoryId: string,
  i18n: I18nInstance,
): string {
  return i18n.t(`categorySlug.${categoryId}`, { ns: "blog" }) || categoryId;
}

export function getCategoryIdFromSlug(
  translatedSlug: string,
  i18n: I18nInstance,
): BlogCategory | null {
  for (const id of allIds) {
    const slug = i18n.t(`categorySlug.${id}`, { ns: "blog" });
    if (slug === translatedSlug) return id as BlogCategory;
  }
  return null;
}

export function getCategoryPrefix(i18n: I18nInstance): string {
  return i18n.t("categoryPrefix", { ns: "blog" }) || "category";
}

export function getAllTranslatedCategorySlugs(
  i18n: I18nInstance,
): { id: string; slug: string }[] {
  return allIds.map((id) => ({
    id,
    slug: getCategorySlug(id, i18n),
  }));
}
